import React from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';
import CustomDatePickerHeader from './CustomDatePickerHeader';

function ExtendedDatePicker({
  isQuarter,
  isStarterComponent,
  handleSetStartDate,
  startDateState,
  endDateState,
  handleSetEndDate,
  isEndVisited
}) {
  const dateForFuture = new Date().getFullYear() + 1;
  const dateForPast = String(new Date().getFullYear() + 1);

  const yearsBack = Array.from(
    { length: Number(dateForPast.slice(-2)) },
    (v, i) => new Date().getFullYear() - Number(dateForPast.slice(-2)) + i + 1
  );
  const yearsFuture = Array.from({ length: 1 }, (v, i) => dateForFuture - i);
  const years = [...yearsBack, ...yearsFuture.reverse()];

  const handleSettingDates = newDate => {
    if (isStarterComponent && !isEndVisited) {
      handleSetStartDate(newDate);
    }

    handleSetEndDate(
      moment(newDate, 'YYYY-MM-DD')
        .endOf(isQuarter ? 'quarter' : 'month')
        .toDate()
    );
  };

  return (
    <>
      <DatePicker
        name="quarter"
        inline
        selected={isStarterComponent ? startDateState : endDateState}
        onChange={handleSettingDates}
        onYearChange={handleSettingDates}
        dateFormat={isQuarter ? 'yyyy, QQQ' : 'MM/yyyy'}
        showQuarterYearPicker={isQuarter}
        renderCustomHeader={({ date, changeYear, increaseYear, decreaseYear }) => (
          <CustomDatePickerHeader
            handleSetEndDate={handleSetEndDate}
            handleSetStartDate={handleSetStartDate}
            isStarterHeader={isStarterComponent}
            date={date}
            changeYear={changeYear}
            increaseYear={increaseYear}
            decreaseYear={decreaseYear}
            years={years}
          />
        )}
        minDate={new Date('2000/01/01')}
        showDisabledMonthNavigation
        showMonthYearPicker={!isQuarter}
      />
    </>
  );
}

ExtendedDatePicker.propTypes = {
  isQuarter: PropTypes.bool.isRequired,
  isStarterComponent: PropTypes.bool.isRequired,
  handleSetEndDate: PropTypes.func.isRequired,
  handleSetStartDate: PropTypes.func.isRequired,
  endDateState: PropTypes.instanceOf(Date).isRequired,
  startDateState: PropTypes.instanceOf(Date).isRequired,
  isEndVisited: PropTypes.bool.isRequired
};

export default ExtendedDatePicker;
